import { render, staticRenderFns } from "./KidSearch.vue?vue&type=template&id=1862197c&"
import script from "./KidSearch.vue?vue&type=script&lang=js&"
export * from "./KidSearch.vue?vue&type=script&lang=js&"
import style0 from "./KidSearch.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports